import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';
import { resolveCardImage } from '../../utils/resolveImage';
import { SEALED_TYPE_LABELS, formatSealedType } from '../../utils/sealedTypes';

var Auth = new AuthService();

var SEALED_TYPE_OPTIONS = [
  { value: 'booster_box', label: 'Booster Box' },
  { value: 'booster_pack', label: 'Booster Pack' },
  { value: 'starter_deck', label: 'Starter Deck' },
  { value: 'anniversary_box', label: 'Anniversary Box' },
];

class AdminSealedProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      pagination: {},
      loading: true,
      search: '',
      searchTimer: null,
      // Filters
      filterSet: '',
      filterSealedType: '',
      filterArchived: '',
      sortBy: 'name_asc',
      availableSets: [],
      availableSealedTypes: [],
      availableGames: [],
      filterGame: '',
      // Expand/Edit
      expandedId: null,
      editingId: null,
      editLoading: false,
      editName: '',
      editSealedType: '',
      editCardSet: '',
      editCardNumber: '',
      editArchived: false,
      editGame: '',
      // Create
      createMode: false,
      createLoading: false,
      createName: '',
      createSealedType: '',
      createCardSet: '',
      createCardNumber: '',
      createGame: '',
      createImageFile: null,
      createImagePreview: null,
      createSortOrder: '',
      createCustomType: '',
      editSortOrder: '',
      // Edit custom type
      editCustomType: '',
      // Image upload
      pendingEditImage: null,
      uploadingImage: false,
      uploadError: '',
    };
    this.fetchProducts = this.fetchProducts.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
    this.handleToggleArchive = this.handleToggleArchive.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.createImageRef = React.createRef();
  }

  componentDidMount() {
    this.fetchProducts(1);
    this.fetchGames();
  }

  fetchGames() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/games')
      .then(function(data) {
        var games = data.games || data || [];
        self.setState({ availableGames: games });
        // Auto-select if only one game
        if (games.length === 1) {
          self.setState({ createGame: games[0].slug, editGame: games[0].slug });
        }
      })
      .catch(function() {});
  }

  getGameSets(gameSlug) {
    if (!gameSlug) return this.state.availableSets;
    var game = this.state.availableGames.find(function(g) { return g.slug === gameSlug; });
    if (!game || !game.setCategories) return this.state.availableSets;
    var sets = [];
    game.setCategories.forEach(function(cat) {
      (cat.sets || []).forEach(function(s) {
        if (sets.indexOf(s) === -1) sets.push(s);
      });
    });
    return sets.sort();
  }

  fetchProducts(page) {
    var self = this;
    self.setState({ loading: true });
    var params = new URLSearchParams();
    params.append('page', page || 1);
    params.append('limit', 25);
    if (self.state.search) params.append('search', self.state.search);
    if (self.state.filterGame) params.append('game', self.state.filterGame);
    if (self.state.filterSet) params.append('cardSet', self.state.filterSet);
    if (self.state.filterSealedType) params.append('sealedType', self.state.filterSealedType);
    if (self.state.filterArchived) params.append('archived', self.state.filterArchived);
    if (self.state.sortBy) params.append('sort', self.state.sortBy);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/sealed-products?' + params.toString())
      .then(function(data) {
        self.setState({
          products: data.products || [],
          pagination: data.pagination || {},
          loading: false,
          availableSets: (data.filters && data.filters.sets) || self.state.availableSets,
          availableSealedTypes: (data.filters && data.filters.sealedTypes) || self.state.availableSealedTypes,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch sealed products:', err);
        self.setState({ loading: false });
      });
  }

  handleSearchChange(e) {
    var self = this;
    var val = e.target.value;
    if (self.state.searchTimer) clearTimeout(self.state.searchTimer);
    self.setState({
      search: val,
      searchTimer: setTimeout(function() { self.fetchProducts(1); }, 400),
    });
  }

  handleCreate() {
    var self = this;
    if (!self.state.createName.trim()) { alert('Product name is required'); return; }
    var sealedType = self.state.createSealedType;
    if (sealedType === '__custom__') {
      if (!self.state.createCustomType.trim()) { alert('Please enter a custom type name'); return; }
      sealedType = self.state.createCustomType.trim().toLowerCase().replace(/\s+/g, '_');
    }
    if (!sealedType) { alert('Sealed type is required'); return; }
    if (!self.state.createCardSet) { alert('Card set is required'); return; }
    self.setState({ createLoading: true });

    var formData = new FormData();
    formData.append('name', self.state.createName);
    formData.append('sealedType', sealedType);
    formData.append('cardSet', self.state.createCardSet);
    if (self.state.createCardNumber) formData.append('cardNumber', self.state.createCardNumber);
    if (self.state.createGame) formData.append('game', self.state.createGame);
    if (self.state.createSortOrder !== '') formData.append('sortOrder', self.state.createSortOrder);
    if (self.state.createImageFile) {
      formData.append('image', self.state.createImageFile);
    }

    fetch(constants.DOMAIN + '/api/v1/admin/sealed-products', {
      method: 'POST',
      headers: { 'Authorization': Auth.getAuthHeader() },
      body: formData,
    })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(d) { throw new Error(d.error || 'Create failed'); });
        return res.json();
      })
      .then(function() {
        self.setState({
          createMode: false, createLoading: false,
          createName: '', createSealedType: '', createCardSet: '',
          createCardNumber: '', createGame: '', createCustomType: '',
          createSortOrder: '', createImageFile: null, createImagePreview: null,
        });
        self.fetchProducts(1);
      })
      .catch(function(err) {
        console.log('Failed to create sealed product:', err);
        self.setState({ createLoading: false });
        alert('Failed to create: ' + (err.message || 'Unknown error'));
      });
  }

  handleSaveEdit() {
    var self = this;
    var id = self.state.editingId;
    if (!id) return;
    self.setState({ editLoading: true });

    var editSealedType = self.state.editSealedType;
    if (editSealedType === '__custom__') {
      if (!self.state.editCustomType.trim()) { alert('Please enter a custom type name'); self.setState({ editLoading: false }); return; }
      editSealedType = self.state.editCustomType.trim().toLowerCase().replace(/\s+/g, '_');
    }

    var formData = new FormData();
    formData.append('name', self.state.editName);
    formData.append('sealedType', editSealedType);
    formData.append('cardSet', self.state.editCardSet);
    if (self.state.editCardNumber !== undefined) formData.append('cardNumber', self.state.editCardNumber);
    formData.append('archived', self.state.editArchived);
    if (self.state.editSortOrder !== '') formData.append('sortOrder', self.state.editSortOrder);
    if (self.state.editGame) formData.append('game', self.state.editGame);

    // Check if there's a pending image upload via file input
    if (self.state.pendingEditImage) {
      formData.append('image', self.state.pendingEditImage);
    }

    fetch(constants.DOMAIN + '/api/v1/admin/sealed-products/' + id, {
      method: 'PATCH',
      headers: { 'Authorization': Auth.getAuthHeader() },
      body: formData,
    })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(d) { throw new Error(d.error || 'Update failed'); });
        return res.json();
      })
      .then(function() {
        self.setState({ editingId: null, editLoading: false, expandedId: null, pendingEditImage: null });
        self.fetchProducts(self.state.pagination.page);
      })
      .catch(function(err) {
        console.log('Failed to update sealed product:', err);
        self.setState({ editLoading: false });
        alert('Failed to update: ' + (err.message || 'Unknown error'));
      });
  }

  handleToggleArchive(productId, currentArchived) {
    var self = this;
    var formData = new FormData();
    formData.append('archived', !currentArchived);
    fetch(constants.DOMAIN + '/api/v1/admin/sealed-products/' + productId, {
      method: 'PATCH',
      headers: { 'Authorization': Auth.getAuthHeader() },
      body: formData,
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Toggle failed');
        return res.json();
      })
      .then(function() {
        self.fetchProducts(self.state.pagination.page);
      })
      .catch(function(err) { console.log('Failed to toggle archive:', err); });
  }

  handleUploadImage(productId) {
    var self = this;
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/gif,image/webp';
    input.onchange = function(e) {
      var file = e.target.files[0];
      if (!file) return;
      self.setState({ uploadingImage: true, uploadError: '' });
      var formData = new FormData();
      formData.append('image', file);
      // Use the sealed product update endpoint with just the image
      fetch(constants.DOMAIN + '/api/v1/admin/sealed-products/' + productId, {
        method: 'PATCH',
        headers: { 'Authorization': Auth.getAuthHeader() },
        body: formData,
      })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.error || 'Upload failed'); });
          return res.json();
        })
        .then(function() {
          self.setState({ uploadingImage: false });
          self.fetchProducts(self.state.pagination.page);
        })
        .catch(function(err) {
          self.setState({ uploadingImage: false, uploadError: err.message || 'Upload failed' });
        });
    };
    input.click();
  }

  startEditing(product) {
    var gameSlug = '';
    if (product.game) {
      if (typeof product.game === 'object' && product.game.slug) {
        gameSlug = product.game.slug;
      } else {
        // Try to match by ObjectId
        var match = this.state.availableGames.find(function(g) { return g._id === product.game || g._id === String(product.game); });
        if (match) gameSlug = match.slug;
      }
    }
    this.setState({
      editingId: product._id,
      editName: product.name || '',
      editSealedType: product.sealedType || '',
      editCardSet: product.cardSet || '',
      editCardNumber: product.cardNumber || '',
      editArchived: product.archived || false,
      editSortOrder: product.sortOrder != null ? String(product.sortOrder) : '0',
      editGame: gameSlug,
    });
    this.setState({ pendingEditImage: null });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var products = this.state.products;
    var pagination = this.state.pagination;

    var inputStyle = {
      width: '100%', padding: '8px 10px', fontSize: '13px', borderRadius: '8px',
      border: isDark ? '1px solid #555' : '1px solid #e0e0e0',
      backgroundColor: isDark ? '#141414' : '#fff',
      color: isDark ? '#fff' : '#1a1a1a', outline: 'none',
    };
    var selectStyle = Object.assign({}, inputStyle, { cursor: 'pointer' });

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
          <div>
            <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">
              <i className="fa fa-cube tw-mr-2" style={{ color: '#7c3aed' }} />Sealed Products
            </h2>
            <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-1">Admin-curated catalog of sealed products</p>
          </div>
          <button
            className="tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: '#7c3aed' }}
            onClick={function() { self.setState({ createMode: !self.state.createMode }); }}
          >
            <i className={'fa ' + (self.state.createMode ? 'fa-times' : 'fa-plus') + ' tw-mr-1.5'} />
            {self.state.createMode ? 'Cancel' : 'New Product'}
          </button>
        </div>

        {/* Create Form */}
        {this.state.createMode && (
          <div className="tw-rounded-xl tw-border-2 tw-mb-4 tw-overflow-hidden" style={{ borderColor: '#7c3aed', backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
            <div className="tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between" style={{ backgroundColor: '#7c3aed' }}>
              <h3 className="tw-text-sm tw-font-bold tw-text-white tw-m-0">
                <i className="fa fa-cube tw-mr-1.5" />New Sealed Product
              </h3>
            </div>
            <div className="tw-p-5">
              <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                {/* Name */}
                <div>
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>
                    Name <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    style={inputStyle}
                    placeholder="e.g. Primal TCG Booster Box - Wave 1"
                    value={this.state.createName}
                    onChange={function(e) { self.setState({ createName: e.target.value }); }}
                  />
                </div>
                {/* Sealed Type */}
                <div>
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>
                    Type <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <select style={selectStyle} value={this.state.createSealedType} onChange={function(e) { self.setState({ createSealedType: e.target.value, createCustomType: '' }); }}>
                    <option value="">Select type...</option>
                    {SEALED_TYPE_OPTIONS.map(function(o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
                    <option value="__custom__">+ New Type...</option>
                  </select>
                  {self.state.createSealedType === '__custom__' && (
                    <input
                      style={Object.assign({}, inputStyle, { marginTop: '6px' })}
                      placeholder="e.g. Elite Trainer Box"
                      value={self.state.createCustomType}
                      onChange={function(e) { self.setState({ createCustomType: e.target.value }); }}
                    />
                  )}
                </div>
                {/* Game */}
                <div>
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>
                    Game <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <select style={selectStyle} value={this.state.createGame} onChange={function(e) { self.setState({ createGame: e.target.value, createCardSet: '' }); }}>
                    <option value="">Select game...</option>
                    {self.state.availableGames.map(function(g) { return <option key={g._id} value={g.slug}>{g.name}</option>; })}
                  </select>
                </div>
                {/* Card Set — filtered by selected game */}
                <div>
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>
                    Card Set <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <select style={selectStyle} value={this.state.createCardSet} onChange={function(e) { self.setState({ createCardSet: e.target.value }); }}>
                    <option value="">{self.state.createGame ? 'Select set...' : 'Select a game first...'}</option>
                    {self.getGameSets(self.state.createGame).map(function(s) { return <option key={s} value={s}>{s}</option>; })}
                  </select>
                </div>
                {/* Sort Order */}
                <div>
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>
                    Sort Order
                  </label>
                  <input
                    style={inputStyle}
                    type="number"
                    min="0"
                    placeholder="0 (lower = first)"
                    value={this.state.createSortOrder}
                    onChange={function(e) { self.setState({ createSortOrder: e.target.value }); }}
                  />
                  <span className="tw-text-[10px] tw-mt-0.5 tw-block" style={{ color: '#999' }}>Controls display order in Browse (lower number appears first)</span>
                </div>
                {/* Image Upload */}
                <div className="md:tw-col-span-2">
                  <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Product Image</label>
                  <div className="tw-flex tw-items-center tw-gap-4">
                    <input
                      ref={this.createImageRef}
                      type="file"
                      accept="image/jpeg,image/png,image/gif,image/webp"
                      style={{ display: 'none' }}
                      onChange={function(e) {
                        var file = e.target.files[0];
                        if (!file) return;
                        self.setState({ createImageFile: file, createImagePreview: URL.createObjectURL(file) });
                      }}
                    />
                    <button
                      className="tw-text-xs tw-px-3 tw-py-2 tw-rounded-lg tw-font-medium tw-border tw-cursor-pointer hover:tw-opacity-80"
                      style={{ borderColor: isDark ? '#555' : '#ddd', backgroundColor: 'transparent', color: isDark ? '#aaa' : '#666' }}
                      onClick={function() { self.createImageRef.current && self.createImageRef.current.click(); }}
                    >
                      <i className="fa fa-upload tw-mr-1" />Choose Image
                    </button>
                    {this.state.createImagePreview && (
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <img src={this.state.createImagePreview} alt="Preview" className="tw-w-12 tw-h-16 tw-object-cover tw-rounded" />
                        <button
                          className="tw-text-xs tw-text-[#EF4444] tw-bg-transparent tw-border-0 tw-cursor-pointer"
                          onClick={function() { self.setState({ createImageFile: null, createImagePreview: null }); }}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Create Buttons */}
              <div className="tw-flex tw-gap-3 tw-mt-5 tw-pt-4" style={{ borderTop: '1px solid rgba(124,58,237,0.2)' }}>
                <button
                  className="tw-text-sm tw-px-6 tw-py-2.5 tw-rounded-xl tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90 tw-shadow-sm"
                  style={{ backgroundColor: '#7c3aed' }}
                  disabled={this.state.createLoading}
                  onClick={this.handleCreate}
                >
                  {this.state.createLoading ? <span><i className="fa fa-spinner fa-spin tw-mr-1" /> Creating...</span> : <span><i className="fa fa-plus tw-mr-1.5" />Create Product</span>}
                </button>
                <button
                  className="tw-text-sm tw-px-5 tw-py-2.5 tw-rounded-xl tw-font-medium tw-border tw-bg-transparent tw-cursor-pointer"
                  style={{ borderColor: isDark ? '#555' : '#d0d0d0', color: isDark ? '#aaa' : '#666' }}
                  onClick={function() { self.setState({ createMode: false }); }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Filters */}
        <div className="tw-rounded-xl tw-border tw-mb-4 tw-p-4" style={{ borderColor: isDark ? '#2a2a2a' : '#e8e8e8', backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
          <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-end">
            {/* Search */}
            <div style={{ flex: '1 1 200px', minWidth: 160 }}>
              <label className="tw-block tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-mb-1" style={{ color: '#999' }}>Search</label>
              <input
                style={inputStyle}
                placeholder="Search by name..."
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>
            {/* Set */}
            <div style={{ flex: '0 1 160px' }}>
              <label className="tw-block tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-mb-1" style={{ color: '#999' }}>Set</label>
              <select style={selectStyle} value={this.state.filterSet} onChange={function(e) { self.setState({ filterSet: e.target.value }, function() { self.fetchProducts(1); }); }}>
                <option value="">All Sets</option>
                {self.state.availableSets.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
              </select>
            </div>
            {/* Type */}
            <div style={{ flex: '0 1 140px' }}>
              <label className="tw-block tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-mb-1" style={{ color: '#999' }}>Type</label>
              <select style={selectStyle} value={this.state.filterSealedType} onChange={function(e) { self.setState({ filterSealedType: e.target.value }, function() { self.fetchProducts(1); }); }}>
                <option value="">All Types</option>
                {SEALED_TYPE_OPTIONS.map(function(o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
              </select>
            </div>
            {/* Archive */}
            <div style={{ flex: '0 1 120px' }}>
              <label className="tw-block tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-mb-1" style={{ color: '#999' }}>Status</label>
              <select style={selectStyle} value={this.state.filterArchived} onChange={function(e) { self.setState({ filterArchived: e.target.value }, function() { self.fetchProducts(1); }); }}>
                <option value="">All</option>
                <option value="false">Active Only</option>
                <option value="true">Archived</option>
              </select>
            </div>
            {/* Sort */}
            <div style={{ flex: '0 1 120px' }}>
              <label className="tw-block tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-mb-1" style={{ color: '#999' }}>Sort</label>
              <select style={selectStyle} value={this.state.sortBy} onChange={function(e) { self.setState({ sortBy: e.target.value }, function() { self.fetchProducts(1); }); }}>
                <option value="sort_order">Sort Order</option>
                <option value="name_asc">A-Z</option>
                <option value="name_desc">Z-A</option>
                <option value="newest">Newest</option>
                <option value="listings">Most Listings</option>
              </select>
            </div>
          </div>
        </div>

        {/* Results count */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <p className="tw-text-xs tw-text-[#999] tw-m-0">
            {pagination.total || 0} product{(pagination.total || 0) !== 1 ? 's' : ''}
            {pagination.pages > 1 ? ' \u00b7 Page ' + pagination.page + ' of ' + pagination.pages : ''}
          </p>
        </div>

        {/* Table */}
        <div className="tw-rounded-xl tw-border tw-overflow-hidden" style={{ borderColor: isDark ? '#2a2a2a' : '#e8e8e8', backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
          {this.state.loading ? (
            <div className="tw-p-8 tw-text-center">
              <i className="fa fa-spinner fa-spin tw-text-xl tw-text-[#999]" />
              <p className="tw-text-sm tw-text-[#999] tw-mt-2 tw-mb-0">Loading sealed products...</p>
            </div>
          ) : products.length === 0 ? (
            <div className="tw-p-8 tw-text-center">
              <i className="fa fa-cube tw-text-3xl tw-text-[#ccc] tw-mb-2" />
              <p className="tw-text-sm tw-text-[#999] tw-mb-0">No sealed products found</p>
            </div>
          ) : (
            <table className="tw-w-full" style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Product</th>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Type</th>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Set</th>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Order</th>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Listings</th>
                  <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Status</th>
                  <th className="tw-px-4 tw-py-3 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map(function(product) {
                  var isExpanded = self.state.expandedId === product._id;
                  var isEditing = self.state.editingId === product._id;
                  var imgSrc = product.image ? (product.image.indexOf('http') === 0 ? product.image : constants.DOMAIN + '/' + product.image) : null;
                  var typeLabel = formatSealedType(product.sealedType);

                  return (
                    <React.Fragment key={product._id}>
                      <tr
                        className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#f9f9f9] dark:hover:tw-bg-[#151515] tw-transition-colors tw-cursor-pointer"
                        onClick={function() { self.setState({ expandedId: isExpanded ? null : product._id, editingId: null }); }}
                      >
                        {/* Product cell */}
                        <td className="tw-px-4 tw-py-3.5">
                          <div className="tw-flex tw-items-center tw-gap-2.5">
                            {imgSrc ? (
                              <img src={imgSrc} alt="" className="tw-w-10 tw-h-14 tw-rounded tw-object-cover tw-flex-shrink-0" />
                            ) : (
                              <div className="tw-w-10 tw-h-14 tw-rounded tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#252525' : '#f0f0f0' }}>
                                <i className="fa fa-cube tw-text-sm" style={{ color: '#7c3aed' }} />
                              </div>
                            )}
                            <div className="tw-min-w-0">
                              <div className="tw-flex tw-items-center tw-gap-1.5">
                                <span className="tw-text-sm tw-font-medium tw-truncate" style={{ maxWidth: 200, color: isDark ? '#fff' : '#1a1a1a' }}>{product.name}</span>
                                {product.archived && (
                                  <span className="tw-text-[9px] tw-px-1.5 tw-py-0.5 tw-rounded tw-font-semibold tw-text-white" style={{ backgroundColor: '#EF4444' }}>Archived</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                        {/* Type */}
                        <td className="tw-px-4 tw-py-3.5 tw-hidden md:tw-table-cell">
                          <span className="tw-text-xs tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: '#7c3aed' }}>{typeLabel}</span>
                        </td>
                        {/* Set */}
                        <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-hidden md:tw-table-cell" style={{ color: isDark ? '#aaa' : '#666' }}>{product.cardSet || '\u2014'}</td>
                        {/* Sort Order */}
                        <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                          <span className="tw-text-xs tw-font-mono" style={{ color: isDark ? '#aaa' : '#666' }}>{product.sortOrder != null ? product.sortOrder : 0}</span>
                        </td>
                        {/* Listings */}
                        <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                          <span className="tw-text-xs" style={{ color: isDark ? '#aaa' : '#666' }}>{product.listingCount || 0}</span>
                          {product.lowestPrice != null && product.lowestPrice > 0 && (
                            <div className="tw-text-[10px]" style={{ color: '#D4A843' }}>${product.lowestPrice.toFixed(2)}</div>
                          )}
                        </td>
                        {/* Status */}
                        <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                          <span className="tw-text-[10px] tw-px-2 tw-py-1 tw-rounded-full tw-font-semibold tw-text-white" style={{ backgroundColor: product.archived ? '#EF4444' : '#10B981' }}>
                            {product.archived ? 'Archived' : 'Active'}
                          </span>
                        </td>
                        {/* Actions */}
                        <td className="tw-px-4 tw-py-3.5 tw-text-right">
                          <button
                            className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#7c3aed]"
                            onClick={function(e) { e.stopPropagation(); self.setState({ expandedId: isExpanded ? null : product._id, editingId: null }); }}
                          >
                            <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')} style={{ fontSize: 11 }} />
                          </button>
                        </td>
                      </tr>

                      {/* Expanded detail/edit row */}
                      {isExpanded && (
                        <tr className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222]">
                          <td colSpan="7" className="tw-px-6 tw-py-5" style={{ backgroundColor: isDark ? '#151515' : '#fafafa' }}>
                            {!isEditing ? (
                              <div>
                                {/* Detail view */}
                                <div className="tw-flex tw-gap-6" style={{ flexWrap: 'wrap' }}>
                                  {/* Image */}
                                  <div style={{ width: 140, flexShrink: 0 }}>
                                    {imgSrc ? (
                                      <img src={imgSrc} alt={product.name} className="tw-w-full tw-rounded-lg tw-shadow" style={{ aspectRatio: '3/4', objectFit: 'cover' }} />
                                    ) : (
                                      <div className="tw-w-full tw-rounded-lg tw-flex tw-items-center tw-justify-center" style={{ aspectRatio: '3/4', backgroundColor: isDark ? '#252525' : '#e8e8e8' }}>
                                        <i className="fa fa-cube tw-text-3xl" style={{ color: '#7c3aed' }} />
                                      </div>
                                    )}
                                    <button
                                      className="tw-w-full tw-mt-2 tw-text-xs tw-py-1.5 tw-rounded-lg tw-font-medium tw-border tw-cursor-pointer hover:tw-opacity-80"
                                      style={{ borderColor: isDark ? '#555' : '#ddd', backgroundColor: 'transparent', color: isDark ? '#aaa' : '#666' }}
                                      disabled={self.state.uploadingImage}
                                      onClick={function(e) { e.stopPropagation(); self.handleUploadImage(product._id); }}
                                    >
                                      {self.state.uploadingImage ? <i className="fa fa-spinner fa-spin" /> : <span><i className="fa fa-upload tw-mr-1" />Upload</span>}
                                    </button>
                                  </div>
                                  {/* Details */}
                                  <div className="tw-flex-1 tw-min-w-0">
                                    <h3 className="tw-text-lg tw-font-bold tw-m-0 tw-mb-3" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{product.name}</h3>
                                    <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mb-3">
                                      <div className="tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e8e8e8') }}>
                                        <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-block" style={{ color: '#999' }}>Type</span>
                                        <span className="tw-text-sm tw-font-medium" style={{ color: '#7c3aed' }}>{typeLabel}</span>
                                      </div>
                                      <div className="tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e8e8e8') }}>
                                        <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-block" style={{ color: '#999' }}>Set</span>
                                        <span className="tw-text-sm tw-font-medium" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{product.cardSet || '\u2014'}</span>
                                      </div>
                                      <div className="tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e8e8e8') }}>
                                        <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-block" style={{ color: '#999' }}>Sort Order</span>
                                        <span className="tw-text-sm tw-font-medium" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{product.sortOrder != null ? product.sortOrder : 0}</span>
                                      </div>
                                      <div className="tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e8e8e8') }}>
                                        <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-block" style={{ color: '#999' }}>Listings</span>
                                        <span className="tw-text-sm tw-font-medium" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{product.listingCount || 0}</span>
                                      </div>
                                      {product.lowestPrice != null && product.lowestPrice > 0 && (
                                        <div className="tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e8e8e8') }}>
                                          <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-block" style={{ color: '#999' }}>Lowest Price</span>
                                          <span className="tw-text-sm tw-font-bold" style={{ color: '#D4A843' }}>${product.lowestPrice.toFixed(2)}</span>
                                        </div>
                                      )}
                                    </div>
                                    <div className="tw-text-xs" style={{ color: isDark ? '#888' : '#999' }}>
                                      Created: {new Date(product.createdAt).toLocaleDateString()}
                                    </div>
                                  </div>
                                </div>
                                {/* Action buttons */}
                                <div className="tw-mt-5 tw-pt-4 tw-flex tw-gap-3" style={{ borderTop: '1px solid rgba(150,150,150,0.2)' }}>
                                  <button
                                    className="tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                                    style={{ backgroundColor: '#3B82F6' }}
                                    onClick={function(e) { e.stopPropagation(); self.startEditing(product); }}
                                  >
                                    <i className="fa fa-pencil tw-mr-1" />Edit
                                  </button>
                                  <button
                                    className="tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                                    style={{ backgroundColor: product.archived ? '#10B981' : '#EF4444' }}
                                    onClick={function(e) { e.stopPropagation(); self.handleToggleArchive(product._id, product.archived); }}
                                  >
                                    <i className={'fa ' + (product.archived ? 'fa-eye' : 'fa-archive') + ' tw-mr-1'} />
                                    {product.archived ? 'Unarchive' : 'Archive'}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              /* Edit form */
                              <div onClick={function(e) { e.stopPropagation(); }}>
                                <h3 className="tw-text-sm tw-font-bold tw-m-0 tw-mb-4" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>
                                  <i className="fa fa-pencil tw-mr-1.5 tw-text-[#3B82F6]" />Edit Sealed Product
                                </h3>
                                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                  <div>
                                    <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Name</label>
                                    <input style={inputStyle} value={self.state.editName} onChange={function(e) { self.setState({ editName: e.target.value }); }} />
                                  </div>
                                  <div>
                                    <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Type</label>
                                    {(function() {
                                      var knownValues = SEALED_TYPE_OPTIONS.map(function(o) { return o.value; });
                                      var isCustomExisting = self.state.editSealedType && knownValues.indexOf(self.state.editSealedType) === -1 && self.state.editSealedType !== '__custom__';
                                      return (
                                        <div>
                                          <select style={selectStyle} value={isCustomExisting ? '__custom__' : self.state.editSealedType} onChange={function(e) { self.setState({ editSealedType: e.target.value, editCustomType: '' }); }}>
                                            {SEALED_TYPE_OPTIONS.map(function(o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
                                            <option value="__custom__">+ New Type...</option>
                                          </select>
                                          {(self.state.editSealedType === '__custom__' || isCustomExisting) && (
                                            <input
                                              style={Object.assign({}, inputStyle, { marginTop: '6px' })}
                                              placeholder="e.g. Elite Trainer Box"
                                              value={isCustomExisting ? self.state.editSealedType : self.state.editCustomType}
                                              onChange={function(e) {
                                                if (isCustomExisting) {
                                                  self.setState({ editSealedType: e.target.value });
                                                } else {
                                                  self.setState({ editCustomType: e.target.value });
                                                }
                                              }}
                                            />
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </div>
                                  <div>
                                    <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Game</label>
                                    <select style={selectStyle} value={self.state.editGame} onChange={function(e) { self.setState({ editGame: e.target.value, editCardSet: '' }); }}>
                                      <option value="">Select game...</option>
                                      {self.state.availableGames.map(function(g) { return <option key={g._id} value={g.slug}>{g.name}</option>; })}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Card Set</label>
                                    <select style={selectStyle} value={self.state.editCardSet} onChange={function(e) { self.setState({ editCardSet: e.target.value }); }}>
                                      <option value="">{self.state.editGame ? 'Select set...' : 'Select a game first...'}</option>
                                      {self.getGameSets(self.state.editGame).map(function(s) { return <option key={s} value={s}>{s}</option>; })}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="tw-block tw-text-xs tw-font-semibold tw-mb-1" style={{ color: isDark ? '#aaa' : '#666' }}>Sort Order</label>
                                    <input style={inputStyle} type="number" min="0" placeholder="0" value={self.state.editSortOrder} onChange={function(e) { self.setState({ editSortOrder: e.target.value }); }} />
                                    <span className="tw-text-[10px] tw-mt-0.5 tw-block" style={{ color: '#999' }}>Lower number appears first in Browse</span>
                                  </div>
                                </div>
                                <div className="tw-flex tw-gap-3 tw-mt-5 tw-pt-4" style={{ borderTop: '1px solid rgba(150,150,150,0.2)' }}>
                                  <button
                                    className="tw-text-sm tw-px-5 tw-py-2 tw-rounded-lg tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                                    style={{ backgroundColor: '#10B981' }}
                                    disabled={self.state.editLoading}
                                    onClick={self.handleSaveEdit}
                                  >
                                    {self.state.editLoading ? <i className="fa fa-spinner fa-spin" /> : <span><i className="fa fa-check tw-mr-1" />Save</span>}
                                  </button>
                                  <button
                                    className="tw-text-sm tw-px-5 tw-py-2 tw-rounded-lg tw-font-medium tw-border tw-bg-transparent tw-cursor-pointer"
                                    style={{ borderColor: isDark ? '#555' : '#d0d0d0', color: isDark ? '#aaa' : '#666' }}
                                    onClick={function() { self.setState({ editingId: null }); }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        {pagination.pages > 1 && (
          <div className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mt-4">
            <button
              className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-cursor-pointer"
              style={{ borderColor: isDark ? '#555' : '#ddd', backgroundColor: 'transparent', color: isDark ? '#aaa' : '#666' }}
              disabled={pagination.page <= 1}
              onClick={function() { self.fetchProducts(pagination.page - 1); }}
            >
              <i className="fa fa-chevron-left" />
            </button>
            <span className="tw-text-xs" style={{ color: '#999' }}>
              Page {pagination.page} of {pagination.pages}
            </span>
            <button
              className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-cursor-pointer"
              style={{ borderColor: isDark ? '#555' : '#ddd', backgroundColor: 'transparent', color: isDark ? '#aaa' : '#666' }}
              disabled={pagination.page >= pagination.pages}
              onClick={function() { self.fetchProducts(pagination.page + 1); }}
            >
              <i className="fa fa-chevron-right" />
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default AdminSealedProducts;
